const TRACKIER_EVENT = {
  SIGN_UP: 'ILqPHp0x1v',
} as const;

export { TRACKIER_EVENT };
